module.exports = __webpack_public_path__ + "img/instagram.f8ab8264.svg";